import reverie_api from '../helpers/reverie_api'

export const LogError = (error) => {
    return reverie_api('log-error', error, 'POST')
}